class Translation {
  constructor (i18n, http, loadFunc) {
    this.http = http
    this.i18n = i18n
    this.i18n.fallbackLocale = this._defaultLanguage
    this.loadFunc = loadFunc
    this.changeLanguage(this._defaultLanguage)
  }
  get _defaultLanguage () {
    return 'en'
  }
  get _supportedLanguages () {
    return ['en', 'fr']
  }
  get currentLanguage () {
    return this.i18n.locale
  }
  set currentLanguage (language) {
    this.i18n.locale = language
  }
  userLanguage () {
    // Get user language
    var l = window.navigator.language || window.navigator.userLanguage

    // Check language
    if (this.isSupportedLanguage(l)) {
      return l
    }

    // Check language without ISO
    l = l.split('-')[0]
    if (this.isSupportedLanguage(l)) {
      return l
    }

    // Default
    return this._defaultLanguage
  }
  changeLanguage (language) {
    // Language is not supported
    if (!this.isSupportedLanguage(language)) return new Error(`Language ${language} not supported`)

    // Language has already been loaded
    if (this.currentLanguage === language) return language

    // Load translation
    const t = this._loadTranslation(language)

    // Update
    this.i18n.setLocaleMessage(language, t.default || t)
    this.currentLanguage = language
    this.http.setLanguage(language)
    return language
  }
  _loadTranslation (language) {
    return this.loadFunc(language)
  }
  isSupportedLanguage (language) {
    return this._supportedLanguages.includes(language)
  }
  route (to, language) {
    if (!language) language = this.currentLanguage
    return {
      ...to,
      params: { language: language, ...to.params }
    }
  }
}

export default Translation
